var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _c("div", [_vm._v("Upload New Users")]),
        _vm.state === "INSTRUCTIONS"
          ? _c("div", { class: _vm.$style.subHeader }, [
              _vm._v(
                " Here you can upload your users using an Excel file. First you will need to download our template and enter your users' information. Then you will upload a completed template so our system can populate your hotel directory users. "
              ),
            ])
          : _vm._e(),
      ]),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody hotel-directory",
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _c("input", {
            ref: "file",
            staticClass: "hidden",
            attrs: {
              type: "file",
              accept:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
            on: { change: _vm.fileChanged },
          }),
          _vm.state === "WORKING"
            ? _c(
                "div",
                [
                  _c("rb-progress-bar", {
                    attrs: { max: 100, value: _vm.progress },
                  }),
                  _c(
                    "div",
                    { class: _vm.$style.loading },
                    [
                      _c("rbv-loading", {
                        attrs: { label: "Loading, please wait..." },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.state === "ERROR"
            ? _c("div", { class: _vm.$style.error }, [
                _vm._v(
                  " Upload encountered an error. Please make sure you are uploading provided Template file. "
                ),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.state !== "WORKING",
              expression: "state !== 'WORKING'",
            },
          ],
          staticClass: "vModalDefaultFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "a",
            {
              staticClass: "rbButton",
              class: _vm.$style.delete,
              attrs: {
                target: "_self",
                href: _vm.file,
                download: "hotel_directory_users",
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("insert_drive_file"),
              ]),
              _vm._v(" Template "),
            ]
          ),
          _c(
            "button",
            {
              staticClass: "rbButton",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v("Cancel")]
          ),
          _c(
            "button",
            {
              staticClass: "rbButton mainButton",
              attrs: { type: "button" },
              on: { click: _vm.select },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("publish")]),
              _vm._v(" Upload Users "),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }